import { useMemo, useEffect } from 'react';
import { useValidate } from '@rmc/webcx-web-libs';
import { useBlocksApiPost } from '../api/v3/web/blocks/post';
import { blockSchema } from '../components/MainApp/blockSchema';
import { WebBlocksApiBlockT } from '../lib/REST/types';

type CampaignsType = {
	id: string;
	visit: number;
	correlationId?: string;
}[];

export function useGetValidCampaigns({
	device,
	userId,
	sessionId,
	previewQuery,
	onLog,
	campaigns,
	clientId,
}: {
	device: string;
	userId: string;
	sessionId: string;
	previewQuery: object;
	onLog: Function;
	campaigns: CampaignsType;
	clientId: string;
}) {
	const { data, error, fetchStatus, isLoading } = useBlocksApiPost({
		campaigns,
		clientId,
		sessionId,
		userId,
		device,
		previewQuery,
	});

	const apiResponse = useMemo(() => data || [], [data]);

	useEffect(() => {
		if (isLoading) {
			return;
		}

		onLog({
			isLoading,
			error,
		});
	}, [fetchStatus, isLoading, error, campaigns]);

	const { valid: validCampaigns, invalid: invalidCampaigns } =
		useValidate<WebBlocksApiBlockT>(apiResponse, blockSchema, onLog);

	return {
		campaigns: validCampaigns,
		invalidCampaigns,
		initialCampaigns: apiResponse,
		isLoading,
		error,
	};
}
